import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger, SplitText, useGSAP);

/* Media-query conditions shared by every story section.
 * - desktop: full pinned storytelling
 * - mobile: no pins, simple reveals
 * - reduceMotion: everything visible, no motion
 * Hidden initial states must be applied via gsap.set()/from() at runtime,
 * never via CSS opacity:0 — prerendered HTML must stay readable without JS. */
export const MM_CONDITIONS = {
  desktop: "(min-width: 768px) and (prefers-reduced-motion: no-preference)",
  mobile: "(max-width: 767.98px) and (prefers-reduced-motion: no-preference)",
  reduceMotion: "(prefers-reduced-motion: reduce)",
} as const;

export { gsap, ScrollTrigger, SplitText, useGSAP };
